import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectUnpopulatedFieldsMessages = createSelector(
  [selectQbrState],
  ({ unpopulatedFieldsMessages }) => unpopulatedFieldsMessages
)
